// extracted by mini-css-extract-plugin
export default {"viewWrapper":"index_viewWrapper__VDZZY","viewLeft":"index_viewLeft__-jh6f"};